import React from "react"
import PartsDiagramViewer from "@/components/PartsViewer/v2/PartsDiagramViewer"
import DetailPopUp from "@/components/PartsViewer/v2/DetailPopUp/"
import GridAndListPanel from "@/components/PartsViewer/v2/GridAndListPanel"
import { LoaderSpinner } from "@/components/PartsViewer/v2/icon"
import ErrorFallbackUI from "@/components/PartsViewer/v2/ErrorFallBack"
import PropTypes from "prop-types"

const DesktopView = props => {
  const {
    selectedFile,
    fullscreen,
    expandHandler,
    partsList,
    setIsListExtend,
    isListExtend,
    title,
    showPopup,
    popupModal,
    setModal,
    productId,
    partController,
    sku,
    loading,
    analytics,
    setWidthSize,
    widthSize,
    showCart,
    setShowCart,
    showCartPopUp,
    setCartToast,
    siteName,
  } = props || {}

  if (loading.error) return <ErrorFallbackUI />
  return (
    <>
      <div
        style={{
          right: popupModal && fullscreen ? widthSize : 0 + "px",
          width: popupModal && fullscreen ? "auto" : "",
        }}
        className={`${isListExtend ? "" : "fullscreen-extend"} left`}
      >
        {!loading?.status ? (
          <PartsDiagramViewer
            expandHandler={expandHandler}
            fullscreen={fullscreen}
            showPopup={showPopup}
            selectedFile={selectedFile}
            partController={partController}
            sku={sku}
            title={title}
            siteName={siteName}
          />
        ) : (
          <LoaderSpinner />
        )}
      </div>
      {!loading?.error ? (
        <div
          className={`${
            isListExtend ? "fullscreen-extend" : ""
          } fullscreen-right h-100`}
        >
          <GridAndListPanel
            partsList={partsList}
            setIsListExtend={setIsListExtend}
            isListExtend={isListExtend}
            title={title}
            showPopup={showPopup}
            partController={partController}
            sku={sku}
            showCart={showCart}
            setShowCart={setShowCart}
            showCartPopUp={showCartPopUp}
            productId={productId}
            analytics={analytics}
            fullscreen={fullscreen}
            setWidthSize={setWidthSize}
            setCartToast={setCartToast}
            selectedFile={selectedFile}
            siteName={siteName}
          />
        </div>
      ) : (
        ""
      )}
      {popupModal ? (
        <DetailPopUp
          productId={productId}
          setModal={setModal}
          partController={partController}
          sku={sku}
          title={title}
          analytics={analytics}
          fullscreen={fullscreen}
          setWidthSize={setWidthSize}
          selectedFile={selectedFile}
          siteName={siteName}
        />
      ) : (
        ""
      )}
    </>
  )
}

DesktopView.propTypes = {
  widthSize: PropTypes.number.isRequired,
  setWidthSize: PropTypes.func.isRequired,
}

export default DesktopView
